import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22.2 22.18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.36 6.86a11 11 0 0 0-6-6A11 11 0 0 0 6.87.85C4.11 1.98 1.97 4.13.83 6.89c-1.12 2.72-1.11 5.68 0 8.33 1.13 2.74 3.26 4.89 6 6.06 1.41.6 2.88.9 4.35.9 1.41 0 2.81-.28 4.15-.83a11 11 0 0 0 6-6 11 11 0 0 0 .01-8.49Zm-1.63 7.82a9.3 9.3 0 0 1-5.06 5.06c-2.29.95-4.83.92-7.14-.07a9.5 9.5 0 0 1-5.07-5.12c-.94-2.23-.94-4.71 0-6.99.96-2.33 2.76-4.14 5.08-5.09 1.15-.47 2.35-.71 3.56-.71s2.44.24 3.6.72c2.31.96 4.11 2.75 5.06 5.06.95 2.3.95 4.84-.01 7.15Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m15.22 13.79-3.76-2.23V6.74c0-.48-.39-.88-.88-.88s-.88.39-.88.88v5.32c0 .31.16.59.43.75l4.19 2.49q.21.12.45.12c.3 0 .59-.15.75-.43.25-.42.11-.95-.3-1.2"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }